import { Expose } from 'class-transformer';
import { GeneralOverviewType } from '../../../enums';

export class GeneralOverviewResponseDto {
    @Expose()
    id: string;

    @Expose()
    clientInformationRecordId: string;

    @Expose()
    overviewType: GeneralOverviewType;

    @Expose()
    isSelected: boolean;
}
